var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRentBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.25H23",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.25V3.75C14 3.55109 13.921 3.36032 13.7803 3.21967C13.6397 3.07902 13.4489 3 13.25 3H4.25C4.05109 3 3.86032 3.07902 3.71967 3.21967C3.57902 3.36032 3.5 3.55109 3.5 3.75V20.25",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20.25V9.75C21.5 9.55109 21.421 9.36032 21.2803 9.21967C21.1397 9.07902 20.9489 9 20.75 9H14",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5H18.5",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.75H18.5",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.9375C9.78553 12.9375 10.625 12.098 10.625 11.0625C10.625 10.027 9.78553 9.1875 8.75 9.1875C7.71447 9.1875 6.875 10.027 6.875 11.0625C6.875 12.098 7.71447 12.9375 8.75 12.9375Z",
    stroke: "#2A3842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9082 14.5781C6.19617 14.0793 6.6104 13.665 7.10924 13.3769C7.60809 13.0889 8.17397 12.9373 8.75 12.9373C9.32603 12.9373 9.89191 13.0889 10.3908 13.3769C10.8896 13.665 11.3038 14.0793 11.5918 14.5781",
    stroke: "#2A3842",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentBuildings);
export default __webpack_public_path__ + "static/media/rentBuildings.99faefb800d2d3f348c9ff9b5ee11315.svg";
export { ForwardRef as ReactComponent };